import PagosRealizados from "../views/modulos/pagosrealizados/List.vue";
const VarRutasPagosRealizados=[
    {
        path: '/PagosRealizados',
        name: 'pagosrealizados',
        component: PagosRealizados,
        props: true
    },
];
export default {
    VarRutasPagosRealizados,
}